module.exports = __webpack_public_path__ + "img/chat.e0e86e26.png";